// extracted by mini-css-extract-plugin
export default {"container":"m0-z","list":"n0-z"};